import React from 'react';
import ButtonBase from './Button';

const Button = props => <ButtonBase {...props} />;

export default Button;
